/* eslint-disable import/no-extraneous-dependencies, import/no-unresolved, import/extensions */
import { createPerimeter } from 'vue-kindergarten';
/* eslint-enable */

export default createPerimeter({
  purpose: 'developer',

  can: {
    // page access guarded by auth-routes.  these rules set up the perimeter for page level access rights

    view () {
      return true;
    },

    // this is really only an OCI administrative function (super).  a developer (at this point) will not be able to change
    // developer, but in the future this could be developed to support a multi-organization developer firm.
    // also allow lenders to view the allDevelopers lists (for now, until need for lockdown)
    viewAllDevelopers() {
      return this.isSuper() || this.isLenderGroup() || this.isPartnerGroup() || this.isOciBrokerManager()
    },

    // for future use we can check to see if the active user is allowed into specific projects for their firm, or all.
    // for now we are allowing a developer firm representative to see all projects in their firm
    viewAllProjects() {
      return this.isSuper() || this.isDeveloperGroup() || this.isPartnerGroup() || this.isOciBrokerManager()
    },
    viewOnlyFirmProjects() {
      return  this.isDeveloperGroup()
    },

    uploadProject() {
      return this.isSuper() || this.isDeveloperAdmin();
    },

    // follow same rules as per upload
    editProject() {
      return this.isAllowed('uploadProject')
    },

    // Dashboard Menu Items
    viewDeveloperDashboard(){
      return this.isSuper() || this.isDeveloperGroup()
    },
    initiateMarketing(){
      return  this.isSuper() || this.isDeveloperMarketer()
    },
    },

  isSuper() {
    return this.child.isSuper;
  },

  isDeveloper() {
    return this.child.isDeveloper;
  },
  isLender() {
    return this.child.isLender;
  },
  isPartner() {
    return this.child.isPartner;
  },

  isDeveloperAdmin() {
    return this.child.isDeveloperAdmin;
  },
  isDeveloperManager() {
    return this.child.isDeveloperManager;
  },
  isDeveloperMarketer() {
    return this.child.isDeveloperMarketer;
  },
  isOciBrokerManager() {
    return this.child.isOciBrokerManager;
  },
  isOciGroup() {
    return this.child.isOciGroup;
  },
  isLenderGroup() {
    return this.child.isLenderGroup;
  },
  isSuperGroup() {
    return this.child.isSuperGroup;
  },
  isDeveloperGroup() {
    return this.child.isDeveloperGroup;
  },
  isPartnerGroup() {
    return this.child.isPartnerGroup;
  },
});
